'use client';

import { c as _c } from "react/compiler-runtime";
import { type AriaToastRegionProps, useToastRegion } from '@react-aria/toast';
import { type ToastState } from '@react-stately/toast';
import { useRef } from 'react';
import { type ToastContent } from '../../constants/constants';
import { Toast } from '../../toast';
import styles from './toast-region.module.scss';
type ToastRegionProps = AriaToastRegionProps & {
  state: ToastState<ToastContent>;
};
export const ToastRegion = t0 => {
  const $ = _c(8);
  let props;
  let state;
  if ($[0] !== t0) {
    ({
      state,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = state;
  } else {
    props = $[1];
    state = $[2];
  }
  const ref = useRef(null);
  const {
    regionProps
  } = useToastRegion(props, state, ref);
  let t1;
  if ($[3] !== state) {
    t1 = state.visibleToasts.map(toast => <Toast key={toast.key} state={state} toast={toast} />);
    $[3] = state;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== regionProps || $[6] !== t1) {
    t2 = <div {...regionProps} className={styles["toast-region"]} ref={ref}>{t1}</div>;
    $[5] = regionProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};